// Sun to Sat
// ISO 8601 week starts on Monday
const DEFAULT_FIRST_DAY = 1;
export function getFirstDayOfTheWeek(locale) {
    try {
        const intlLocale = new Intl.Locale(locale);
        // Older runtimes (e.g. Firefox) don't implement getWeekInfo, so guard at runtime.
        if (typeof intlLocale.getWeekInfo === 'function') {
            const firstDay = intlLocale.getWeekInfo().firstDay;
            if (firstDay !== undefined) {
                return firstDay === 7 ? 0 : firstDay;
            }
        }
        return getFirstDayManual(locale);
    } catch  {
        return getFirstDayManual(locale);
    }
}
// CLDR v48 region data (2024-01-08)
// Source: https://github.com/unicode-org/cldr-json/blob/main/cldr-json/cldr-core/supplemental/weekData.json
// prettier-ignore
const REGIONS_STARTING_SATURDAY = [
    'AF',
    'BH',
    'DJ',
    'DZ',
    'EG',
    'IQ',
    'IR',
    'JO',
    'KW',
    'LY',
    'OM',
    'QA',
    'SD',
    'SY'
];
// prettier-ignore
const REGIONS_STARTING_SUNDAY = [
    'AG',
    'AS',
    'BD',
    'BR',
    'BS',
    'BT',
    'BW',
    'BZ',
    'CA',
    'CO',
    'DM',
    'DO',
    'ET',
    'GT',
    'GU',
    'HK',
    'HN',
    'ID',
    'IL',
    'IN',
    'IS',
    'JM',
    'JP',
    'KE',
    'KH',
    'KR',
    'LA',
    'MH',
    'MM',
    'MO',
    'MT',
    'MX',
    'MZ',
    'NI',
    'NP',
    'PA',
    'PE',
    'PH',
    'PK',
    'PR',
    'PT',
    'PY',
    'SA',
    'SG',
    'SV',
    'TH',
    'TT',
    'TW',
    'UM',
    'US',
    'VE',
    'VI',
    'WS',
    'YE',
    'ZA',
    'ZW'
];
const LANGUAGES_STARTING_SATURDAY = [
    'ar'
];
// prettier-ignore
const LANGUAGES_STARTING_SUNDAY = [
    'en',
    'he',
    'hi',
    'id',
    'ja',
    'ko',
    'pt',
    'tl',
    'th'
];
// Fallback for browsers without Intl.Locale.getWeekInfo() support (e.g., Firefox)
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getWeekInfo
// Uses CLDR region data. For Wix-supported language-only locales, uses inferred defaults.
function getFirstDayManual(locale) {
    try {
        const intlLocale = new Intl.Locale(locale);
        const language = intlLocale.language?.toLowerCase();
        const region = intlLocale.region?.toUpperCase();
        if (region) {
            if (REGIONS_STARTING_SUNDAY.includes(region)) {
                return 0;
            }
            if (REGIONS_STARTING_SATURDAY.includes(region)) {
                return 6;
            }
            return DEFAULT_FIRST_DAY;
        }
        if (language) {
            if (LANGUAGES_STARTING_SUNDAY.includes(language)) {
                return 0;
            }
            if (LANGUAGES_STARTING_SATURDAY.includes(language)) {
                return 6;
            }
        }
        return DEFAULT_FIRST_DAY;
    } catch  {
        return DEFAULT_FIRST_DAY;
    }
}

//# sourceMappingURL=get-first-day-of-the-week.js.map